
define('ldsh!modules/editor/templates/elements/form_button', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<!-- <div class="js-control js-submit-wrapper"> -->\n<div class="js-control">\n  <button class="btn btn-default js-submit" form="lpg-form"/>\n</div>\n';

}
return __p
};});

